import React, { ReactElement, useCallback, useState } from 'react';

import styled, { useTheme } from 'styled-components';

import { TooltipProps } from '@mui/material/Tooltip';
import { OverlayView, OverlayViewF } from '@react-google-maps/api';
import { Tooltip } from 'components';

const TooltipWrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  pointer-events: none;
  width: 1px;
  height: 1px;
`;

type Props = {
  id: string;
  position: {
    lat: number;
    lng: number;
  };
  tooltip?: string | ReactElement | null;
  open?: boolean;
  className?: string;
  tooltipProps?: Partial<TooltipProps>;
  zIndex?: number;
  children?: React.ReactElement;
};

export const MarkerTooltipOverlay: React.FC<Props> = ({
  id,
  position,
  tooltip,
  open = false,
  className,
  tooltipProps,
  zIndex,
  children,
}) => {
  const theme = useTheme();
  const [loaded, setLoaded] = useState(false);

  const onLoad = useCallback(() => {
    if (tooltipProps?.open) {
      setTimeout(() => {
        setLoaded(true);
      }, 100);
    } else {
      setLoaded(true);
    }
  }, [tooltipProps?.open]);

  return (
    <OverlayViewF
      key={id}
      zIndex={zIndex || 10}
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      onLoad={onLoad}
    >
      {tooltip && loaded ? (
        <Tooltip
          title={tooltip}
          {...tooltipProps}
          open={open || !!tooltipProps?.open}
          PopperProps={{ disablePortal: true }}
          componentsProps={{
            ...tooltipProps?.componentsProps,
            tooltip: {
              className,
              ...tooltipProps?.componentsProps?.tooltip,
              style: {
                borderColor: theme.custom.palette.info600,
                backgroundColor: 'white',
                borderWidth: '2px',
                borderStyle: 'solid',
                color: theme.custom.palette.darkText,
                ...tooltipProps?.componentsProps?.tooltip?.style,
              },
            },
          }}
        >
          {children || <TooltipWrapper />}
        </Tooltip>
      ) : (
        children
      )}
    </OverlayViewF>
  );
};
